import {Injectable} from '@angular/core';
import {ApiParams, ApiService} from './api.service';
import {PagedList} from '../models/entity.model';
import {PackItem, packItemMapper} from '../models/pack-item.model';

export type SearchTypeFilter = 'prompt' | 'pack' | null

@Injectable({
  providedIn: 'root'
})
export class SearchService extends ApiService {
  protected readonly mapper = packItemMapper

  search(search: string, typeFilter: SearchTypeFilter = null) {
    const params: ApiParams = { q: search }
    if (typeFilter) params['type'] = typeFilter
    return this.mapper.mapList(this.get<PagedList<PackItem>>('search', { params }))
  }
}
